import { useSelector } from "react-redux";
import { RootState } from "@/app/store";

/**
 * Plausibilitätsprüfung, um den Anmeldestatus eines Users festzustellen.
 */
export const useIsAuthenticated = (): boolean => {
    /**
     * Zugriff auf den Redux Store, um den Token zu prüfen.
     * Üblicherweise schneller als Zugriff über localStorage.
     */
    const token = useSelector((state: RootState) => state.auth.token);

    // Stellt lediglich sicher, dass der Token nicht leer ist
    return token.length > 18;
};
